import React, { Component } from "react";
// import "../ViewAdSet.scss";
import AdSetDataStore from "../../../../Flux/Stores/AdSetDataStore";
import BookFiltersStore from "../../../../Flux/Stores/BookFiltersStore";
import MasterCampaignsStore from "../../../../Flux/Stores/MasterCampaignsStore";
import NewAdSet from "../../../Modals/NewAdSet";
import EditAdSet from "../../../Modals/EditAdSet";
import DeleteAdSet from "../../../Modals/DeletePlatformModal";
import MultiplierModal from "../../../Modals/MultiplierModal";
import DuplicatePlatformModal from "../../../Modals/DuplicatePlatformModal";
import FindReplaceModal from "../../../Modals/FindReplaceModal";
import LoadingIcon from "../../../../Components/LoadingSpinner";
import Table from "../../../../Components/Table/Table";
import { TOOLBAR_MODE, EDIT_BUTTON_LOCATION } from "@acadia-ui/toolbar";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import Modal from "@acadia-ui/modal";
import { retryAtInterval } from "../retryAtInterval";
import applyFindReplaceToTable from "../applyFindReplaceToTable";
import FullFiltersSidesheet, { fullFilterAlgorithm } from "../FullFiltersSidesheet";
import WorkbookStore from "../../../../Flux/Stores/WorkbookStore";
import TraffickingRequestModal from "../../../Modals/TraffickingRequestModal";
import _ from "lodash";
import { COLUMNS } from "../../../../Components/ShowHideColumns";
import TraffickingDataStore from "../../../../Flux/Stores/TraffickingDataStore";
import { showToast, TOAST_TYPE, ToastNotification } from "@acadia-ui/toast";
import { draftHLISelected } from "../../../../Helpers/ActionHelpers";

class LegacyAdSetView extends Component {
	constructor() {
		super();
		this.state = {
			isHidden: false,
			selectedRow: {},
			adSetsToDelete: [],
			readOnly: true,
			selectedCount: 0,
			selectedRows: [],
			success: false,
			successMessage: null,
			delete: false,
			singleSelected: false,
			multipleSelected: false,
			searchValue: "",
			filteredData: null,
			advancedFilter: false,
			displayFilter: false,
			extraColumns: [],
			search: ""
		};

		this.dataTableApi = React.createRef();

		this.filterChoices = BookFiltersStore.getChoicesState();
		this.parentCampaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
	}

	getAdSets = () => {
		const adSetData = AdSetDataStore.getData();
		let siteOptions = null;
		if (AdSetDataStore.getConfig().AdSetData !== undefined) {
			AdSetDataStore.getConfig().AdSetData.forEach((option) => {
				if (option.Name === "PlatformSiteID") {
					siteOptions = option.Options;
				}
			});
		}
		if (siteOptions !== null) {
			adSetData.forEach((adset) => {
				if (adset.PlatformSiteID !== null) {
					let platformName = null;
					siteOptions.forEach((site) => {
						if (adset.PlatformSiteID === site.OptionID) {
							platformName = site.OptionLabel;
						}
					});
					if (platformName !== null) {
						adset.PlatformSiteID = platformName;
					}
				}
			});
		}
		this.setState({
			adSetConfig: AdSetDataStore.getConfig(),
			adSetData: AdSetDataStore.getData(),
			loading: false
		});
	};

	componentDidMount = () => {
		const adSetConfig = AdSetDataStore.getConfig();
		if (adSetConfig.length === 0) {
			this.props.getCount(this.getAdSets, "AdSet");
		} else {
			this.getAdSets();
		}
		AdSetDataStore.on("adsets_success", this.gridChanged);
		AdSetDataStore.on("adsets_edit_success", this.gridChanged);
		AdSetDataStore.on("create_and_add_adsets_success", this.gridChanged);
		AdSetDataStore.on("adset_deleted", this.adSetDeleted);
		WorkbookStore.on("enabled_columns_fetched", this.setEnabledColumns);
		TraffickingDataStore.on("submit_trafficking_success", this.submitTraffickingSuccess);

		this.setEnabledColumns();
	};

	componentWillUnmount = () => {
		AdSetDataStore.removeListener("adsets_success", this.gridChanged);
		AdSetDataStore.removeListener("adsets_edit_success", this.gridChanged);
		AdSetDataStore.removeListener("create_and_add_adsets_success", this.gridChanged);
		AdSetDataStore.removeListener("adset_deleted", this.adSetDeleted);
		WorkbookStore.removeListener("enabled_columns_fetched", this.setEnabledColumns);
		TraffickingDataStore.removeListener("submit_trafficking_success", this.submitTraffickingSuccess);
	};

	componentDidUpdate = (prevProps, prevState) => {
		if (!_.isEqual(prevState.extraColumns, this.state.extraColumns)) {
			// force rerender of table
			this.setState({ isHidden: true }, () => {
				this.setState({ isHidden: false });
			});
		}
	};

	setEnabledColumns = () => {
		const JIRAStatus = WorkbookStore.getIsTrafficEnabled();
		const enabledColumns = [];

		if (JIRAStatus) {
			enabledColumns.push(...COLUMNS.TRAFFIC_MANAGER);
			enabledColumns.push(COLUMNS.DO_NOT_USE);
		}

		enabledColumns.push(COLUMNS.IsDraft);

		const auditLevel = this.props.auditLevelData.find(({ AuditLevelName }) => AuditLevelName == "AdSet")?.AuditLevelID;
		const Preferences = WorkbookStore.getEnabledColumns()?.find(({ HierarchyLevelID }) => HierarchyLevelID == auditLevel)?.Preferences;
		const parsedPreferences = Preferences ? JSON.parse(Preferences) : null;

		if (parsedPreferences && parsedPreferences instanceof Object) {
			this.setState({
				extraColumns: enabledColumns.map(({ id, name, selected }) => ({
					id,
					name,
					selected: parsedPreferences?.[id] ?? selected
				}))
			});
		} else {
			this.setState({ extraColumns: enabledColumns });
		}
	};

	adSetDeleted = () => {
		if (this.state.filteredData !== null) {
			this.setState({ filteredData: LineItemDataStore.getFilteredData() });
		}
		this.gridChanged();
		showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message={`${this.props.vanityName || "Ad Set"} deleted successfully.`} timed={5000} />);
		this.props.updateCounts();
	};

	gridChanged = () => {
		const adSetData = AdSetDataStore.getData();
		let siteOptions = null;
		AdSetDataStore.getConfig().AdSetData.forEach((option) => {
			if (option.Name === "PlatformSiteID") {
				siteOptions = option.Options;
			}
		});
		if (siteOptions !== null) {
			adSetData.forEach((adset) => {
				if (adset.PlatformSiteID !== null) {
					let platformName = null;
					siteOptions.forEach((site) => {
						if (adset.PlatformSiteID === site.OptionID) {
							platformName = site.OptionLabel;
						}
					});
					if (platformName !== null) {
						adset.PlatformSiteID = platformName;
					}
				}
			});
		}

		let preparredData;

		if (Object.keys(this.state.filterOptions ?? {})?.length > 0) {
			this?.dataTableApi?.current?.dataProvider?.update?.(adSetData);
			preparredData = fullFilterAlgorithm({
				handleFilter: () => {},
				config: AdSetDataStore.getConfig(),
				data: AdSetDataStore.getData(),
				dataTableApi: this.dataTableApi,
				filterOptions: this.state.filterOptions
			});
		} else {
			preparredData = AdSetDataStore.getData();
		}

		this.setState({ adSetData: preparredData, loading: false });
	};

	refetchData = (callback) => {
		const auditLevelArray = [];
		this.props.auditLevelData.forEach((auditLevel) => {
			auditLevelArray.push({ value: auditLevel.AuditLevelID, label: auditLevel.AuditLevelName });
		});
		const choices = JSON.parse(JSON.stringify(this.filterChoices));
		let auditLevelChoice = null;
		auditLevelArray.forEach((auditLevel) => {
			if (auditLevel.label === "AdSet") {
				auditLevelChoice = auditLevel;
			}
		});
		if (auditLevelChoice !== null) {
			choices.auditlevel = auditLevelChoice;
			this.setState({ readOnly: true, searchValue: "", advancedFilter: false, displayFilter: false });
			this.props.updateCounts("AdSet").then(() => {
				this.gridChanged();
				callback?.();
			});
		}
	};

	openModal = () => {
		this.newAdSetModal.triggerOpenClose();
	};

	editAdSet = () => {
		this.setSelectedRow(() => {
			this.editAdSetModal.triggerOpenClose();
		});
	};

	deleteAdSet = () => {
		const selectedUniqueIDs = this.state.selectedRows.map((row) => {
			return row.UniqueID;
		});
		const selectedLines = JSON.parse(JSON.stringify(AdSetDataStore.getData()))
			.map((row, index) => {
				row.Row = index;
				return row;
			})
			.filter((row) => {
				return selectedUniqueIDs.includes(row.UniqueID);
			});

		this.setState({ adSetsToDelete: selectedLines }, () => {
			this.deleteAdSetModal.triggerOpenClose();
		});
	};

	formatDate = (date) => {
		const d = new Date(date);
		let month = String(d.getMonth() + 1);
		let day = String(d.getDate());
		const year = d.getFullYear();

		if (month.length < 2) month = "0" + month;
		if (day.length < 2) day = "0" + day;

		return [year, month, day].join("/");
	};

	duplicateAdSet = () => {
		this.setSelectedRow(() => {
			this.duplicateAdSetModal.triggerOpenClose();
		});
	};

	setSelectedRow = (callback) => {
		const selectedLine = this.state.selectedRows[0];
		const dataArr = {};
		Object.keys(selectedLine).forEach((key) => {
			if ((key === "EndDate" || key === "StartDate") && selectedLine[key] !== "") {
				dataArr[key] = this.formatDate(selectedLine[key]);
			} else if (key === "Cost" || key === "Budget") {
				dataArr[key] = selectedLine[key].replace(/[^\d.-]/g, "");
			} else if (key !== "UniqueID" && key !== "AdSetName") {
				dataArr[key] = selectedLine[key];
			}
		});
		this.setState({ selectedRow: dataArr }, () => {
			callback?.();
		});
	};

	openMultiplierModal = () => {
		this.setSelectedRow(() => {
			this.multiplierModal.triggerOpenClose();
		});
	};

	unlockSheet = () => {
		this.setState({
			readOnly: !this.state.readOnly,
			success: false,
			successMessage: null,
			delete: false
		});
	};

	numberSelected = (row, chk, selectAll = false) => {
		let newSelectedRows = this.state.selectedRows;
		if (!selectAll) {
			if (chk) {
				newSelectedRows.push(row);
			} else {
				newSelectedRows = newSelectedRows.filter((selectedRow) => {
					return selectedRow.UniqueID != row.UniqueID;
				});
			}
		} else {
			newSelectedRows = row;
		}
		this.setState({
			selectedRows: newSelectedRows,
			selectedCount: newSelectedRows.length,
			success: false,
			delete: false,
			singleSelected: newSelectedRows.length === 1,
			multipleSelected: newSelectedRows.length > 1
		});
	};

	returnSearchedValues = (searchTerm) => {
		const searchableFields = [];
		const filteredData = [];
		const configKeys = Object.keys(this.state.adSetConfig);
		configKeys.forEach((bucket) => {
			if (Array.isArray(this.state.adSetConfig[bucket])) {
				this.state.adSetConfig[bucket].forEach((field) => {
					if (field.IsSummarizedHeader === true) {
						searchableFields.push(field.Name);
					}
				});
			}
		});
		this.state.adSetData.forEach((data) => {
			for (const field of searchableFields) {
				if (data[field]) {
					if (data[field].toLowerCase().includes(searchTerm.toLowerCase())) {
						filteredData.push(data);
						break;
					}
				}
			}
		});
		return filteredData;
	};

	clearSearch = () => {
		this.setState({
			adSetData: AdSetDataStore.getData(),
			searchValue: "",
			success: false,
			successMessage: null,
			advancedFilter: false,
			displayFilter: false
		});
		document.getElementById("searchAdSet").value = "";
	};

	replaceData = (data, toggleEditing = false) => {
		applyFindReplaceToTable({
			data,
			dataTableApi: this.dataTableApi,
			toggleEditing,
			syncData: (updatedData) => {
				this.setState({ adSetData: updatedData });
			}
		});
	};

	handleFilter = (filteredData, applyFilter, filterOptions) => {
		if (!document.getElementById("AdSet_find_replace_modal")?.hasAttribute("open")) {
			if (applyFilter === true) {
				this.setState({
					adSetData: filteredData,
					advancedFilter: true,
					displayFilter: false,
					filterOptions
				});
			} else if (this.state.searchValue !== "") {
				const filteredData = this.returnSearchedValues(this.state.searchValue);
				if (filteredData.length !== 0) {
					this.setState({
						adSetData: filteredData,
						advancedFilter: false,
						displayFilter: false,
						filterOptions: []
					});
				} else {
					this.setState({ adSetData: AdSetDataStore.getData(), advancedFilter: false, displayFilter: false, filterOptions: [] });
				}
			} else {
				this.setState({ adSetData: AdSetDataStore.getData(), advancedFilter: false, displayFilter: false, filterOptions: [] });
			}
		}
	};

	handleDuplicate = (dataWithDuplicates, totalCount) => {
		const name = this.props.vanityName ? this.props.vanityName : "Ad Set";
		showToast(
			"workbookToasts",
			<ToastNotification
				type={TOAST_TYPE.SUCCESS}
				message={`${name}  have been successfully created in bulk. Confirm all fields in the table have been entered.`}
				timed={10000}
			/>
		);
		this.setState({ adSetData: dataWithDuplicates, readOnly: false }, () => {
			this.dataTableApi.current.dataProvider.currentPage = 0;
			retryAtInterval(
				() => this.dataTableApi?.current?.toolbarApi?.current?.changeActiveMode?.(TOOLBAR_MODE.EDIT),
				() => this.dataTableApi?.current?.toolbarApi?.current?.activeMode === TOOLBAR_MODE.EDIT
			);
		});
	};

	handleMultiply = (dataWithMultipliedRows) => {
		const name = this.props.vanityName ? this.props.vanityName : "Ad Set";
		showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message={`${name}s multiplied successfully.`} timed={10000} />);
		this.setState({ adSetData: dataWithMultipliedRows, readOnly: false }, () => {
			this.dataTableApi.current.dataProvider.currentPage = 0;
			retryAtInterval(
				() => this.dataTableApi?.current?.toolbarApi?.current?.changeActiveMode?.(TOOLBAR_MODE.EDIT),
				() => this.dataTableApi?.current?.toolbarApi?.current?.activeMode === TOOLBAR_MODE.EDIT
			);
		});
	};

	handleRowSelection = (selectedRows) => {
		this.setState({
			selectedRows
		});
	};

	openTraffickingModal = () => {
		// Modal.show(`AdSet_trafficking_request_modal`);
		this.traffickingModal.triggerOpenClose();
	};

	submitTraffickingSuccess = () => {
		this.setState({ loading: true, singleSelected: false, multipleSelected: false, selectedCount: 0 }, () => {
			this.refetchData(() => {
				this.traffickingModal.triggerOpenClose();
				Modal.hide("LineItem_trafficking_request_modal");
			});
			this.setState({ data: AdSetDataStore.getData(), searchValue: "", filteredPackage: null, loading: false });
		});
	};

	render() {
		const { adSetConfig, adSetData } = this.state;
		const auditLevelID = this.props.auditLevelData.find(({ AuditLevelName }) => AuditLevelName == "AdSet")?.AuditLevelID;
		const TMEnabled = WorkbookStore.getIsTrafficEnabled();

		return (
			<section className="tab__container">
				{!this.state.isHidden && (
					<>
						{adSetData && adSetConfig && (
							<>
								{!this.state.isHidden ? (
									<Table
										ref={this.dataTableApi}
										data={adSetData}
										config={adSetConfig}
										hierarchyLevel="AdSet"
										vanityName={this.props.vanityName || "Ad Set"}
										JIRAStatus={TMEnabled}
										metaData={this.props.campaignMetaData}
										// updateSelected={this.numberSelected}
										updateSelected={this.handleRowSelection}
										refetchData={this.refetchData}
										auditLevelID={auditLevelID}
										extraColumns={this.state.extraColumns}
										search={this.state.search}
										onSearch={(searchValue) => {
											this.setState({ search: searchValue });
										}}
										actionBarProps={{
											filtersSideSheet: (
												<FullFiltersSidesheet
													TMEnabled={TMEnabled}
													hierarchyLevel="AdSet"
													ref={this.dataTableApi}
													data={AdSetDataStore.getData()}
													config={adSetConfig}
													handleFilter={this.handleFilter}
													filterOptions={this.state.filterOptions}
												/>
											),
											editButton: (
												<Button
													// this comment exists to prevent eslint from making this unreadable.
													style={{ order: 2 }}
													display={BUTTON_DISPLAY.SECONDARY}
													size={BUTTON_SIZE.SMALL}
													data-tracking-id-alt="open-edit-adset-details-modal"
												>
													Edit Details
												</Button>
											),
											showEditMode: EDIT_BUTTON_LOCATION.DEFAULT_MODE_ACTIONS,
											defaultModeActions: [
												<Button
													style={{ order: 1 }}
													size={BUTTON_SIZE.SMALL}
													display={BUTTON_DISPLAY.TEXT}
													key="adset-find-replace"
													onClick={() => {
														this.findReplaceModal.triggerOpenClose();
													}}
													data-tracking-id-alt="open-ad-set-find-replace-modal"
												>
													Find and Replace
												</Button>,
												<Button
													style={{ order: 3 }}
													size={BUTTON_SIZE.SMALL}
													key="add-adset"
													onClick={() => {
														this.newAdSetModal.triggerOpenClose();
													}}
													data-tracking-id-alt="open-add-ad-set-modal"
												>
													Add {this.props.vanityName || "Ad Set"}
												</Button>
											],
											actions: [
												<Tooltip
													key="action-clone"
													title={`Clone ${this.props.vanityName ? this.props.vanityName : "Ad Set"}s`}
													position={TOOLTIP_POSITION.BOTTOM_START}
												>
													<Button
														size={BUTTON_SIZE.SMALL}
														display={BUTTON_DISPLAY.ICON_BORDERED}
														icon="icon-copy"
														onClick={() => {
															Modal.show(`${this.props.vanityName ? this.props.vanityName : "Ad Set"}_clone_modal`);
														}}
														data-tracking-id-alt="open-clone-ad-set-modal"
														disabled={draftHLISelected(this.dataTableApi)}
													>
														Clone
													</Button>
												</Tooltip>,
												<Tooltip
													key="action-multiply"
													title={`Multiply ${this.props.vanityName ? this.props.vanityName : "Ad Set"}`}
													position={TOOLTIP_POSITION.BOTTOM_START}
												>
													<Button
														size={BUTTON_SIZE.SMALL}
														display={BUTTON_DISPLAY.ICON_BORDERED}
														icon="icon-copy-clipboard"
														onClick={() => {
															Modal.show(`${this.props.vanityName ? this.props.vanityName : "Ad Set"}_multiplier`);
														}}
														disabled={this.state.selectedRows.length > 1 || draftHLISelected(this.dataTableApi)}
														data-tracking-id-alt="open-ad-set-multiplier-modal"
													>
														{this.props.vanityName ? this.props.vanityName : "Ad Set"} Multiplier
													</Button>
												</Tooltip>,
												<Tooltip key="edit-adset" title="Edit" position={TOOLTIP_POSITION.BOTTOM_START}>
													<Button
														icon="icon-pencil"
														display={BUTTON_DISPLAY.ICON_BORDERED}
														size={BUTTON_SIZE.SMALL}
														disabled={this.state.selectedRows?.length !== 1}
														onClick={() => {
															this.editAdSetModal.triggerOpenClose();
														}}
														data-tracking-id-alt="open-edit-ad-set-modal"
													>
														Edit {this.props.vanityName || "Ad Set"}
													</Button>
												</Tooltip>,
												<Tooltip key="action-delete" title={`Delete ${this.props.vanityName || "Ad Set"}`} position={TOOLTIP_POSITION.BOTTOM_START}>
													<Button
														size={BUTTON_SIZE.SMALL}
														display={BUTTON_DISPLAY.ICON_BORDERED}
														icon="icon-trash"
														onClick={() => {
															this.deleteAdSet();
														}}
														disabled={this.state.selectedRows.length === 0}
														data-tracking-id-alt="open-delete-ad-set-modal"
													>
														Delete {this.props.vanityName || "Ad Set"}
													</Button>
												</Tooltip>,
												TMEnabled ? (
													<Tooltip key="action-traffic-request" title="Start traffic request" position={TOOLTIP_POSITION.BOTTOM_START}>
														<Button
															size={BUTTON_SIZE.SMALL}
															display={BUTTON_DISPLAY.ICON_BORDERED}
															icon="icon-play"
															onClick={this.openTraffickingModal}
															disabled={
																!(TMEnabled === true && this.state.selectedRows.every((row) => row.TraffickingPlacementStatusID === "5")) ||
																draftHLISelected(this.dataTableApi)
															}
															data-tracking-id-alt="ad-set-open-traffic-request-modal"
														>
															Start traffic request
														</Button>
													</Tooltip>
												) : (
													<></>
												)
											]
										}}
									/>
								) : (
									<LoadingIcon />
								)}
							</>
						)}

						<NewAdSet
							newAdSet={(ref) => {
								this.newAdSetModal = ref;
							}}
							config={adSetConfig}
							filters={this.filterChoices}
							metaData={this.props.campaignMetaData}
							updateCounts={this.props.updateCounts}
							vanityName={this.props.vanityName}
							auditLevelID={auditLevelID}
						/>
						<EditAdSet
							editAdSet={(ref) => {
								this.editAdSetModal = ref;
							}}
							config={adSetConfig}
							filters={this.filterChoices}
							data={this.state.selectedRows[0]}
							metaData={this.props.campaignMetaData}
							vanityName={this.props.vanityName}
							auditLevelID={auditLevelID}
						/>
						<DeleteAdSet
							deletePlatformModal={(ref) => {
								this.deleteAdSetModal = ref;
							}}
							type={`${this.props.vanityName ? this.props.vanityName : "Ad Set"}`}
							data={this.state.adSetsToDelete}
							multiple={true}
							deleteType="deleteAdSet"
							hierarchyLevel="AdSet"
							onSubmit={() => {
								// this.props.updateCounts();
							}}
							onFailure={this.refetchData}
						>
							<div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
								{this.state.selectedRows.map((line) => (
									<div key={line.AdSetName}>{line.AdSetName}</div>
								))}
							</div>
						</DeleteAdSet>
						<DuplicatePlatformModal
							config={adSetConfig}
							type={`${this.props.vanityName ? this.props.vanityName : "Ad Set"}`}
							data={this.state.selectedRows}
							handleDuplicate={this.handleDuplicate}
							allRows={adSetData}
						/>
						<MultiplierModal
							data={this.state.selectedRows[0]}
							handleMultiply={this.handleMultiply}
							allRows={adSetData}
							config={adSetConfig}
							type="Ad Set"
							hierarchyLevel="AdSet"
							name={`${this.props.vanityName ? `${this.props.vanityName}` : "Ad Set"}`}
						/>
						<FindReplaceModal
							findReplaceModal={(ref) => {
								this.findReplaceModal = ref;
							}}
							type={"AdSet"}
							hierarchyLevel="AdSet"
							config={adSetConfig}
							data={adSetData}
							replaceData={this.replaceData}
							tableRef={this.dataTableApi}
						/>

						<TraffickingRequestModal
							traffickingModal={(ref) => {
								this.traffickingModal = ref;
							}}
							selectedRows={this.state.selectedRows}
							campaignMetaData={this.props.campaignMetaData}
							campaignJIRATicket={this.props.campaignJiraTicketExists}
							hierarchyLevel="AdSet"
						/>
					</>
				)}
			</section>
		);
	}
}

export default LegacyAdSetView;
